import { render } from "./ActionMenuComponent.vue?vue&type=template&id=51dd479c"
import script from "./ActionMenuComponent.vue?vue&type=script&lang=js"
export * from "./ActionMenuComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__